export enum CTA_TYPE {
  PREORDER = 'PREORDER',
  ADD_TO_CART = 'ADD_TO_CART',
  WAITLIST = 'WAITLIST',
}
